import { FlexColumn } from '@/components/shared/components/FlexColumn';
import { Font } from '@/components/shared/components/Font';
import { ENV_ENV } from '@/config/envVars';

export const ErrorMessageDefault = ({ error }: { error: Error }) => {
  return (
    <FlexColumn>
      <Font variant={'body2'} style={{ wordBreak: 'break-all' }}>
        <strong>{error.message}</strong>
      </Font>
      {ENV_ENV === 'dev' && (
        <Font variant={'caption'} style={{ wordBreak: 'break-all' }}>
          {error.stack}
        </Font>
      )}
    </FlexColumn>
  );
};
